<template>
  <div id="Ec" v-show="true">
    <div class="tableItem1 no-border-top">
      <div class="tips" style="margin:0 9px;">
        <img src="../../assets/jpg/tips.svg" alt="" />
        <span class="china">每日16:00更新昨日数据，所有数据统计从2026/05/14开始</span>
      </div>
      <div v-if="loading1" v-loading="loading1" style="height: 60px"></div>
      <div v-else>
        <div class="title" style="padding: 0px 11px 0px;margin:25px auto">
          <span class="titleBIg china">品牌各渠道达成</span>
          <span class="titleSmall china">截至{{ this.RefreshTime | dateFormat }}</span>
        </div>
        <tableBrand :ChangeFlag="ActiveFlag" :TableList1="tableData" v-if="dataShow"></tableBrand>
        <div v-else v-loading="loading" style="height: 60px">
          <tableBrand></tableBrand>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tableBrand from "./tableBrand.vue";
export default {
  data() {
    return {
      ActiveFlag: "tab2",
      tableData: [],
      AllData: [],
      LargetStData: [],
      CrossData: [],
      dataShow: false,
      loading: true,
      loading1: true,
      RefreshTime: "",
    };
  },
  methods: {
    getTablist() {
      this.$addr
        .post("SalesNew/getOtherBrands")
        .then((res) => {
          this.dataShow = true;
          this.loading1 = false;
          this.tableData = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getTime() {
      this.$addr
        .post("SalesNew/getSalesFGSRealTimeRefreshData")
        .then((res) => {
          this.RefreshTime = res.data.data.t1_date;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  components: {
    tableBrand,
  },
  created() {
    this.getTablist();
    this.getTime();
  },
  mounted() { },
};
</script>
<style scoped>
.china {
  font-family: "微软雅黑" !important;
}

.tips {
  background: #ededed;
  border-radius: 5px;
  text-align: center;
  padding: 2px;
  margin-bottom: 25px;

}

.tips span {
  font-family: "Heiti SC";
  font-style: normal;
  font-weight: normal;
  font-size: 9px;
  line-height: 20px;
  color: #000;
}

.title {
  color: #000;
}

.title .titleBIg {
  font-size: 22px;
  margin-right: 8px;
}

.title .titleSmall {
  font-size: 12px;
}


.tableItem1 {
  margin: 0 auto 12px;
  padding: 25px 14px 0;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}



#Ec {
  border-radius: 0 0 20px 20px;
  height: 100%;
  overflow: hidden;
}

.no-border-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/WarRoom/Ec.vue